<template>
    <div>
        <div class="popup__content">
            <div class="text-size-l text-bold text-color mb24">
                {{ title }}
            </div>
            <div class="input-select" style="width: 100%">
                <input-select-new v-model="form.topSection.value" :options="topSectionsOptions" :placeholder="'Макрораздел'" :list-style="{'max-height': 'none'}" :disabled="false"></input-select-new>
            </div>
            <div class="input-select mt16" style="width: 100%" v-if="form.subLocation.value">
                <input-select-new v-model="form.subLocation.value" :options="tempSections.length ? tempSections : sections" :placeholder="'Макрораздел'" :list-style="{'max-height': 'none'}" :disabled="false"></input-select-new>
            </div>
            <div style="width: 100%;text-transform: uppercase;" class="mt16">
                <input-styled
                :auto-focus="true"
                name="category"
                :placeholder="'Название категории'"
                :placeholderInput="'Название'"
                @enter="send"
                v-model="form.category.text"
                @focus="form.category.error=false"
                :maxLengthNum="20"
                :is-error="form.category.error">
                </input-styled>
            </div>
            <div class="save-error" v-if="showError">
                <div class="save-error__title">Внимание</div>
                <div class="save-error__subtitle">После этого действия все правила<br>
                    в категории «<span class="text-uppercase">{{this.newSubLocationName}}</span>»<br>
                    будут перемещены в автоматически созданную подкатегорию «РАЗОБРАТЬ»
                </div>
            </div>
            <div class="row-b mt24">
                <div class="row-b__col elem-pos-fix mr24">
                    <submit-btn class="btn btn--ico" @click.native="send" :type="form.btnType">
                        <span v-if="form.btnType=='normal'" class="i i-ok7 mr8"></span>Сохранить
                    </submit-btn>
                </div>
            </div>
            <div class="remove-rule" @click="removeCat" v-if="section.name">
                <a href="javascript:void(0);" class="link-icon link-icon__modal">
                    <span class="i i-trash2"></span>
                    <span class="text">Удалить <span v-if="form.subLocation.value">под</span>категорию</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InputStyled from '@/components/forms/InputStyled.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import InputSelectNew from '@/components/forms/InputSelectNew.vue';

    export default {
        name: "RuleCategory",
        components: {
            InputStyled,
            SubmitBtn,
            InputSelectNew,
        },
        mounted(){
            this.form.category.text = this.section.name;
            this.form.topSection.value = this.activeTopSection;
            this.form.subLocation.value = this.newSubSectionLocation.id;

            this.$parent.$on('close', this.cleanup);
        },
        beforeUnmount() {
            this.$parent.$off('close', this.cleanup);
        },
        data() {
            return {
                form:{
                    topSection: {
                        value: '',
                        error: false,
                    },
                    subLocation: {
                        value: '',
                        error: false,
                    },
                    category: {
                        text: '',
                        error: false,
                    },
                    btnType: 'normal'
                },
                showError: false,
                accept: false,
                sectionsInitialized: false,
            }
        },
        methods: {
            cleanup() {
                this.$store.commit('rules/setNewSubSectionLocation', false);
                this.$store.commit('rules/setEditSection', []);
            },
            removeCat: function(){
                    this.$store.dispatch('rules/removeSection', {
                    id: this.section.id,
                    topSection: this.newSubSectionLocation ? this.newSubSectionLocation.id : this.activeTopSection,
                }).then(response => {

                    this.$store.commit('popups/close', {name: this.popups.ruleCategory.name});


                  if (response.data.error === 403) {
                    this.$store.commit('popups/open', {name: this.popups.sectionForbiddenError.name});
                  } else {
                    if(response.data.result.done){
                      if (this.activeSection == this.section.id) {
                        if (typeof (this.sections[0]) !== 'undefined') {
                          this.$router.push('/sid' + this.activeTopSection + '/sub' + this.sections[0].id + '/');
                        } else {
                          this.$router.push('/sid' + this.activeTopSection + '/');
                        }
                      }
                    }
                    else{
                      this.openRemoveCatError();
                    }
                  }

                });
            },
            openRemoveCatError: function () {
                this.$store.commit('popups/open', {name: this.popups.removeCatError.name});
            },
            send(){
                let error = false;
                if(!this.form.category.text || this.form.category.text.length == 0){
                    if(this.form.category.error){
                        this.form.category.error = false;
                        setTimeout(() => {
                            this.form.category.error = true;
                        }, 10);
                    }else{
                        this.form.category.error = true;
                    }
                    error = true;
                }
                let section = this.section.id;
                if(!error){
                    this.form.btnType = 'load';
                    let params = {
                        name: this.form.category.text,
                        id: this.section.id ? this.section.id : false,
                        topSection: this.form.subLocation.value ? this.form.subLocation.value : this.form.topSection.value,
                        activeTopSection: this.activeTopSection,
                        isTop: false,
                        isSub: this.form.subLocation.value && !this.section ? true : false,
                    };
                    if (this.showError === true) {
                        params.force = true;
                    }
                    this.$store.dispatch('rules/setSection', params).then((data)=>{
                        if(data.error === 450) {
                            this.showError = true;
                            this.form.btnType = 'normal';
                            return;
                        }
                        this.form.btnType = 'normal';

                        if (data.id) {

                            this.$store.commit('rules/setItemsLocal', {
                                items: []
                            });
                            
                            this.$store.dispatch('rules/getItems', {id: this.activeSection, reload: true})
                        }

                      this.$store.commit('popups/close', {name: this.popups.ruleCategory.name});
                      this.cleanup();

                      if (data.error === 403) {
                        this.$store.commit('popups/open', {name: this.popups.sectionForbiddenError.name});
                      }

                        this.$nextTick(()=>{
                            setTimeout(()=>{
                                // На всякий случай очистим данные для редактирования раздела
                                this.$store.commit('rules/setEditSection',[]);
                                if(section){
                                    this.$store.commit('popups/close', {name: this.popups.ruleCategory.name});

                                    let routePath = '/sid'+this.form.topSection.value+'/sub'+section+'/';
                                    if (routePath !== this.$router.history.current.path) {
                                      this.$router.push({path: routePath});
                                    }

                                } else if(data.id) {
                                    this.$store.commit('popups/close', {name: this.popups.ruleCategory.name});

                                    let routePath = '/sid'+this.form.topSection.value+'/sub'+data.id+'/';
                                    if (routePath !== this.$router.history.current.path) {
                                      this.$router.push({path: routePath});
                                    }
                                }
                            }, 200);
                        })
                    });
                }
            },
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                section: state => state.rules.editSection,
                sections: state => state.rules.sections,
                tempSections: state => state.rules.tempSections,
                topSections: state => state.rules.topSections,
                newSubSectionLocation: state => state.rules.newSubSectionLocation,
            }),
            topSectionsOptions() {
              let options = [];

              for(let i in this.topSections) {
                if (this.topSections[i].rights === 'W' || this.topSections[i].rights === 'C') {
                  options.push(this.topSections[i]);
                }
              }

              return options;
            },
            activeSection(){
                return this.$route.params.subid ? this.$route.params.subid : ((typeof(this.sections[0]) !== 'undefined') ? this.sections[0].id : 0);
            },
            activeTopSection(){
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
            title() {
                return this.form.subLocation.value ? 'Подкатегория' : 'Категория';
            },
            newSubLocationName() {
                const subLocationId = this.form.subLocation.value;
                if (!subLocationId) return '';
                
                const sectionsToSearch = this.tempSections.length > 0 ? this.tempSections : this.sections;
                const section = sectionsToSearch.find(section => section.id === subLocationId);
                
                return section ? section.name : '';
            },
        },
        watch: {
            'form.topSection.value'(newVal) {
                if (!newVal) return;
                
                this.$store.dispatch('rules/getTempSections', { id: newVal }).then(() => {
                    
                    const isInList = this.tempSections.some(
                        (section) => section.id === this.form.subLocation.value
                    );
                    
                    if (this.form.subLocation.value && !isInList) {
                        this.form.subLocation.value = this.tempSections[0] ? this.tempSections[0].id : '';
                    }

                });
            },
        },

    }
</script>

<style scoped>

</style>
